import { i18n } from '../services/i18n.js';
import { dbSim } from '../services/dbSim.js';
import { auth } from '../services/auth.js';
import { icon } from '../services/icons.js';
import { playerSession } from '../services/playerSession.js';

export const JoinView = (container) => {
  const hashParts = window.location.hash.split('?');
  const query = hashParts[1] || '';
  const urlParams = new URLSearchParams(query);
  const queryPin = urlParams.get('pin') || '';

  let session = null;
  let game = null;

  const render = () => {
    container.innerHTML = `
      <div style="flex:1; display:flex; align-items:center; justify-content:center; padding: 40px 24px; min-height:85vh; background: var(--color-bg);">
        <div class="card" style="width:100%; max-width:400px; text-align:center; padding:36px; box-shadow: var(--shadow-premium);">
          <h1 style="font-size:24px; font-weight:800; margin-bottom:6px; letter-spacing:-0.5px;">${icon('heart')} Heart150</h1>
          <p style="color: var(--color-text-secondary); font-size:13px; margin-bottom:28px;">
            ${i18n.t('join_intro')}
          </p>

          <form id="joinGameForm">
            <!-- Phase 1: PIN Input -->
            <div class="form-group" style="text-align:left;">
              <label class="form-label" for="joinPinInput">${i18n.t('join_pin')}</label>
              <input type="text" id="joinPinInput" class="input-field" value="${queryPin}" inputmode="numeric" pattern="[0-9]{4}" minlength="4" maxlength="4" autocomplete="one-time-code" placeholder="Ví dụ: 1501" style="text-align:center; font-size:24px; font-weight:800; letter-spacing:4px;" required />
            </div>

            <!-- Phase 2: Dynamic Nickname or Google Auth -->
            <div id="joinPhase2" style="display:none; margin-top:20px; border-top:1px solid var(--color-border); padding-top:20px; text-align:left;">
              <!-- Dynamic Content -->
            </div>
          </form>
        </div>
      </div>
    `;

    const pinInput = container.querySelector('#joinPinInput');
    
    // Listen for PIN input changes to query session
    pinInput.addEventListener('input', checkPinState);
    
    if (queryPin) {
      checkPinState();
    }
  };

  const checkPinState = async () => {
    const pinInput = container.querySelector('#joinPinInput');
    const pin = pinInput.value.replace(/\D/g, '').slice(0, 4);
    pinInput.value = pin;
    const phase2Container = container.querySelector('#joinPhase2');

    if (pin.length === 4) {
      session = await dbSim.getSessionByPin(pin);
      if (session) {
        const savedPlayer = playerSession.get();
        if (savedPlayer?.sessionId === session.id && savedPlayer?.pin === session.pin) {
          try {
            await dbSim.resumePlayer(session.id);
            window.location.hash = '#/play';
            return;
          } catch {
            playerSession.clear();
          }
        }
        game = { requirePlayerLogin: session.requirePlayerLogin };
        showPhase2(phase2Container);
      } else {
        phase2Container.style.display = 'none';
        window.showToast(i18n.t('invalid_pin'));
      }
    } else {
      phase2Container.style.display = 'none';
    }
  };

  const showPhase2 = (phase2El) => {
    phase2El.style.display = 'block';
    
    if (game.requirePlayerLogin) {
      phase2El.innerHTML = `
        <div style="text-align:center;">
          <p style="font-size:12px; color:var(--color-text-secondary); margin-bottom:16px; font-weight:600; text-transform:uppercase;">
            ${icon('lock')} ${i18n.t('player_auth_required')}
          </p>
          <button type="button" id="playerGoogleLoginBtn" class="btn btn-secondary" style="width:100%; display:flex; justify-content:center; gap:12px; padding:12px; font-size:14px; border-color: rgba(255,255,255,0.15);">
            ${icon('key')}
            ${i18n.t('sign_in_google')}
          </button>
        </div>
      `;

      phase2El.querySelector('#playerGoogleLoginBtn').addEventListener('click', async () => {
        try {
          localStorage.setItem("h150_login_role", "player");
          localStorage.setItem("h150_player_session_id", session.id);
          localStorage.setItem("h150_player_pin", session.pin);
          
          auth.login(`/#/join?pin=${session.pin}`);
        } catch (err) {
          console.error("[Join] OAuth Error:", err);
          window.showToast("Lỗi đăng nhập: " + err.message);
        }
      });

    } else {
      phase2El.innerHTML = `
        <div class="form-group">
          <label class="form-label" for="joinNicknameInput">${i18n.t('join_nickname')}</label>
          <input type="text" id="joinNicknameInput" class="input-field" minlength="2" maxlength="20" autocomplete="nickname" placeholder="${i18n.t('nickname_placeholder')}" style="text-align:center; font-weight:700;" required />
        </div>
        <button type="submit" class="btn btn-primary" style="width:100%; padding:14px; font-size:16px; font-weight:700; box-shadow: var(--shadow-glow); margin-top:8px;">
          ${i18n.t('join_btn')} ${icon('arrowRight')}
        </button>
      `;

      // Handle Form Submit (Traditional nickname entry)
      container.querySelector('#joinGameForm').addEventListener('submit', (e) => {
        e.preventDefault();
        const nickname = container.querySelector('#joinNicknameInput').value.trim();
        if (nickname) {
          completeJoin(nickname, null);
        }
      });
    }
  };

  const completeJoin = async (nickname, email) => {
    try {
      // 1. Add participant
      const part = await dbSim.addParticipant(session.id, nickname, email);

      // 2. Save player profile in session storage
      const playerProfile = {
        participantId: part.id,
        nickname: part.nickname,
        email: part.email,
        pin: session.pin,
        sessionId: session.id,
        playerToken: part.playerToken
      };
      playerSession.save(playerProfile);

      // 3. Worker broadcasts PLAYER_JOINED through the room Durable Object.
      // 4. Redirect to play view
      window.showToast(`${nickname}: ${i18n.t('welcome_lobby')}.`);
      window.location.hash = '#/play';

    } catch (err) {
      window.showToast(err.message);
    }
  };

  render();
};
